module.exports = __webpack_public_path__ + "static/img/screening-funnel.732e82b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/screening-funnel.svg?data
// module id = 6y/8
// module chunks = 1